<div class="batch-upload-container">
  <!-- Batch Creation Section -->
  <div class="create-batch-container">
    <!-- Batch List Component -->
    <div class="batch-list-container">
      <app-batch-list
        [tenantId]="tenantId"
        (openBatchEvent)="openBatch($event)"
      >
        @if (canPerformAction('CREATE_BATCH') | async) {
          <div
            class="header-right"
            createBatchButton
          >
            <p-button
              label="{{ 'createBatch' | translate }}"
              class="dap-start-batch-creation"
              icon="fa-solid fa-rectangle-history-circle-plus"
              size="large"
              severity="secondary"
              [attr.aria-label]="'createBatch' | translate"
              (click)="startBatchCreation()"
            >
            </p-button>
          </div>
        }
      </app-batch-list>
    </div>
  </div>
</div>
